module.exports = __webpack_public_path__ + "img/skate_gold.d9fbb2d0.png";